<template>
  <v-card
    elevation="0"
    style="width: 840px; margin-right: 140px"
  >
    <v-card-title
      class="pt-0 d-flex justify-space-between"
      style="height: 52px;"
    >
      <div>
        {{ $t('overview.overview') }}
      </div>
      <div>
        <v-btn
          icon
          small
          color="primary"
          @click="refreshProfile"
        >
          <v-icon :size="18">
            mdi-refresh
          </v-icon>
        </v-btn>
      </div>
    </v-card-title>
    <v-alert
      v-if="successfulPaymentAlert || paymentResult ==='success'"
      color="success"
      text
      class="mb-0"
      dismissible
    >
      {{ $t('common.successfulPayment') }}
    </v-alert>
    <v-alert
      v-if="paymentResult ==='error'"
      color="red"
      type="error"
      text
      class="mb-0"
      dismissible
    >
      {{ $t('common.failedPayment') }}
    </v-alert>
    <v-alert
      v-if="paymentResult ==='inprocess'"
      color="red"
      type="warning"
      text
      class="mb-0"
      dismissible
    >
      {{ $t('common.paymentInprocess') }}
    </v-alert>
    <v-alert
      v-if="paymentResult ==='cancel'"
      color="red"
      type="warning"
      text
      class="mb-0"
      dismissible
    >
      {{ $t('common.paymentCancelled') }}
    </v-alert>
    <v-alert
      v-if="successfulUpgradeAlert"
      color="success"
      type="success"
      text
      class="mb-0"
      dismissible
    >
      {{ $t('plans.yourSubscriptionHasBeenUpdated') }}
    </v-alert>

    <custom-plan-banner v-if="profile.subscription && !profile.subscription.isCustomTariff" />

    <v-card-text>
      <v-row>
        <!-- E-MAIL АККАУНТА -->
        <v-col cols="4">
          {{ $t("overview.accountEmail") }}
        </v-col>
        <v-col
          cols="8"
          class="text-end"
        >
          {{ profile.username }}
        </v-col>

        <div class="custom-divider" />


        <!-- ПАРОЛЬ -->
        <!-- <v-col cols="4">
          {{ $t("overview.password") }}
        </v-col>
        <v-col
          cols="8"
          class="text-end"
        >
          overview.password
        </v-col>

        <div class="custom-divider" /> -->

        <!-- МЕССЕНФЖЕР -->
        <v-col cols="6">
          <span v-if="selectedMessenger && selectedMessengerValue">
            {{ $t(`quiz.messenger.${selectedMessenger}`) }}
         </span>

          <span v-if="!selectedMessengerValue">
            {{ $t("common.contact") }}
         </span>
        </v-col>
        <v-col
          cols="6"
          class="text-end"
        >
          <div class="d-flex justify-end align-center">
             {{ selectedMessengerValue }}
            <v-btn
              small
              rounded
              outlined
              color="primary"
              class="ml-2"
              @click="handleChangeMessenger"
            >
              <span v-if="selectedMessengerValue">
                 {{ $t('common.change') }}
              </span>
              <span v-else>
                 {{ $t('common.add') }}
              </span>
            </v-btn>
          </div>
        </v-col>
        <div class="custom-divider" />
        <!-- Двухфакторная аутентификация -->

        <v-col
          v-if="'twoFactorEnableDisable' in profile"
          cols="6"
        >
          {{ $t('common.twoFactorAuthentication') }}
        </v-col>
        <v-col
          v-if="'twoFactorEnableDisable' in profile"
          cols="6"
          class="text-end"
        >
          <div
            v-if="!profile.twoFactorEnableDisable"
            class="d-flex justify-end align-center"
          >
            {{ $t('common.off') }}
            <v-btn
              small
              rounded
              outlined
              color="primary"
              class="ml-2"
              @click="handleTwoFactorAuthEnableClick"
            >
              {{ $t('common.enable') }}
            </v-btn>
          </div>

          <div
            v-else
            class="d-flex justify-end align-center"
          >
            <div class="twoFactorOnText">
              {{ $t('common.on') }}
            </div>
            <v-btn
              small
              rounded
              outlined
              color="primary"
              class="ml-2"
              @click="handleTwoFactorAuthManageClick"
            >
              {{ $t('common.manage') }}
            </v-btn>
          </div>
        </v-col>

        <div class="custom-divider" />
        <!-- ПЛАН -->
        <v-col
          v-if="profile.subscription && profile.subscription.plan"
          cols="4"
        >
          {{ $t("overview.plan") }}
        </v-col>
        <v-col
          v-if="profile.subscription && profile.subscription.plan"
          cols="8"
          class="text-end"
        >
          {{ planName }}
          <v-btn
            v-if=" profile.subscription.plan === 'trial' "
            id="overviewButtonPay"
            small
            rounded
            color="primary"
            class="ml-2"
            @click="goToTrialPlansCards"
          >
            {{ $t('common.pay') }}
          </v-btn>
          <v-btn
            v-else
            id="overviewButtonPay"
            small
            rounded
            color="primary"
            class="ml-2"
            @click="goToPlansCards"
          >
            {{ $t('common.upgrade') }}
          </v-btn>
        </v-col>

        <div
          v-if="profile.subscription && profile.subscription.plan"
          class="custom-divider"
        />

        <!-- ДЕЙСТВИТЕЛЕН ДО -->
        <v-col
          v-if="profile.subscription"
          cols="4"
        >
          {{ $t("overview.expires") }}
        </v-col>
        <v-col
          v-if="profile.subscription"
          cols="8"
          class="text-end"
        >
          {{ profile.subscription.expiration ? moment(profile.subscription.expiration).format('DD MMM YYYY') : $t('overview.perpetual') }}

          <div
            v-if="!isFreeOfCharge()"
            style="display: inline-block"
          >
            <v-btn
              v-if=" profile.subscription.plan !== 'trial' "
              small
              rounded
              outlined
              color="primary"
              class="ml-2"
              @click="renewPlan"
            >
              {{ $t('common.renew') }}
            </v-btn>
          </div>
        </v-col>

        <div
          v-if="profile.subscription && profile.subscription.expiration"
          class="custom-divider"
        />
        <!-- ПРОФИЛИ -->
        <v-col
          v-if="profile.subscription && profile.subscription.browserProfiles"
          cols="4"
        >
          {{ $t("common.browserProfiles") }}
        </v-col>
        <v-col
          v-if="profile.subscription && profile.subscription.browserProfiles"
          cols="8"
          class="text-end"
          :style="{color: countsColor(profile.subscription.browserProfiles.count, profile.subscription.browserProfiles.limit)}"
        >
          {{ profile.subscription.browserProfiles.count + " /" }}
          <span style="font-weight: bold;">
            {{ profile.subscription.browserProfiles.limit }}
          </span>
        </v-col>

        <div
          v-if="profile.subscription && profile.subscription.browserProfiles"
          class="custom-divider"
        />

        <template v-if="isFreePlanWithSingleProfile">
          <!-- Созданные профили -->
          <v-col cols="4">
            {{ $t("common.createdPerMonth") }}
          </v-col>
          <v-col
            cols="8"
            class="text-end"
            :class="countsColorClass"
          >
            {{ profilesCountForCurrentMonth }}
            <span class="limitForCurrentMonth-span">
              {{ profile.subscription.browserProfiles.limitForCurrentMonth }}
            </span>
          </v-col>
          <div class="custom-divider" />

          <!-- Лимит -->
          <v-col cols="4">
            {{ $t("common.resetLimit") }}
          </v-col>
          <v-col
            cols="8"
            class="text-end"
          >
            {{ nextMonthFirstDate }}
          </v-col>
          <div class="custom-divider" />
        </template>

        <!-- ЮЗЕРЫ -->
        <v-col
          v-if="profile.subscription && profile.subscription.users"
          cols="4"
        >
          {{ $t("common.users") }}
        </v-col>
        <v-col
          v-if="profile.subscription && profile.subscription.users"
          cols="8"
          class="text-end"
          :style="{color: countsColor(profile.subscription.users.count, profile.subscription.users.limit)}"
        >
          {{ profile.subscription.users.count + " /" }}
          <span style="font-weight: bold;">
            {{ profile.subscription.users.limit }}
          </span>
        </v-col>

        <div
          v-if="showNewsletterDivider"
          class="custom-divider"
        />

        <v-col v-if="showNewsletterSwitcher" cols="12" class="d-flex pa-0">
          <v-col cols="4" class="d-flex align-center">
            {{ $t("common.newsletter") }}
          </v-col>

          <v-col
            cols="8"
            class="d-flex justify-end pr-0"
          >
            <v-switch
              :input-value="showNewsletter"
              inset
              hide-details
              class="mt-0 pa-0"
              @change="changeNewsletter"
            />
          </v-col>
        </v-col>

        <div
          v-if="profile.subscription && profile.subscription.browserProfiles"
          class="custom-divider"
        />

        <!-- ПЛАТЕЖИ -->
        <v-col
          v-if="activePlan && profile.subscription && profile.subscription.expiration"
          cols="4"
        >
          {{ $t("overview.billing") }}
        </v-col>
        <v-col
          v-if="activePlan && profile.subscription && profile.subscription.expiration"
          cols="8"
          class="text-end"
        >
          {{
            profile.subscription.subscriptionId ? $t('overview.yourPlanWillRenewOn') : $t('overview.yourPlanWillNotRenewOn')
          }}
          {{ moment(profile.subscription.expiration).format('DD MMM YYYY') }}
        </v-col>

        <div
          v-if="profile.subscription && profile.subscription.subscriptionId"
          class="custom-divider"
        />

        <!-- ОТПИСАТЬСЯ -->
        <v-col
          v-if="profile.subscription && profile.subscription.subscriptionId"
          cols="12"
          class="text-end"
        >
          <span
            class="linkable-span"
            style="color: #BDBDBD"
            @click="$store.dispatch('main/openDialog', 'unsubscribe')"
          >
            {{ $t('overview.unsubscribe') }}
          </span>
        </v-col>

        <black-friday-banner v-if="showBlackFridayBanner" />
        <cloud-experiments-banner-wrapper v-if="cloudExperiment" :experiment-data="cloudExperiment" />
        <back-to-school-banner v-if="showBackToSchoolBanner" />
      </v-row>
    </v-card-text>
    <!-- ДИАЛОГИ -->
    <prolong-plan-dialog
      v-if="dialogs.prolongPlan"
    />

    <dialog-nps-quiz
      v-if="mainDialogs.npsQuiz"
    />

    <custom-plan-more-profiles-dialog
      v-if="mainDialogs.customPlanMoreProfiles"
    />

    <change-messenger-contact
      v-if="openDialogChangeMessenger"
      :selected-messenger-value="selectedMessengerValue"
      @saveDialogChangeMessenger="saveDialogChangeMessenger"
      @closeDialogChangeMessenger="changeMessengerDialog"
    />

    <contact-change-restriction-dialog
      v-if="contactChangeRestriction"
      @closeContactRestrictionDialog="changeRestrictionDialog"
    />
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'
import ProlongPlanDialog from '@/components/plans/dialogs/ProlongPlanDialog'
import DialogNpsQuiz from '@/components/dialogs/DialogNpsQuiz.vue'
import CloudExperimentsBannerWrapper from '@/components/banners/CloudExperimentsBannerWrapper.vue'
import { EXPERIMENT_CLOUD_KEY_NAME } from '@/constants/experiments'
import Cookies from 'js-cookie'
import BackToSchoolBanner from '@/components/banners/BackToSchoolBanner.vue'
import BlackFridayBanner from '@/components/banners/BlackFridayBanner.vue'
import featureFlags from '@/mixins/featureFlags'
import prolongPlan from '@/mixins/prolongPlan'
import CustomPlanMoreProfilesDialog from '@/components/dialogs/CustomPlanMoreProfilesDialog.vue'
import CustomPlanBanner from '@/components/banners/CustomPlanBanner.vue'
import ChangeMessengerContact from '@/components/dialogs/ChangeMessengerContact.vue'
import ContactChangeRestrictionDialog from '@/components/dialogs/ContactChangeRestrictionDialog.vue'

export default {
  name: 'Overview',

  components: {
    ContactChangeRestrictionDialog,
    ChangeMessengerContact,
    CustomPlanMoreProfilesDialog,
    CustomPlanBanner,
    BackToSchoolBanner,
    CloudExperimentsBannerWrapper,
    ProlongPlanDialog,
    DialogNpsQuiz,
    BlackFridayBanner
  },

  mixins: [
    featureFlags,
    prolongPlan
  ],

  data() {
    return {
      moment,
      refreshLoading: false,
      paymentResult: false,
      enableTwoFactorAuthModalOpened: true,
      cloudExperimentsGroup: '',
      localShowNewsletter: false,
      openDialogChangeMessenger: false,
      contactChangeRestriction: false
    }
  },

  computed: {
    ...mapGetters({
      profile: 'main/profile',
      dialogs: 'plans/dialogs',
      mainDialogs: 'main/dialogs',
      successfulPaymentAlert: 'main/successfulPaymentAlert',
      successfulUpgradeAlert: 'main/successfulUpgradeAlert',
      paymentDeclineAlert: 'main/paymentDeclineAlert',
      paymentCancelAlert: 'main/paymentCancelAlert',
      banners: 'main/banners',
      experiments: 'experiments/experiments',
      selectedMessenger: 'main/selectedMessenger',
      selectedMessengerValue: 'main/selectedMessengerValue',
      userChangedContactThisMonth: 'main/userChangedContactThisMonth',
    }),
    planName () {
      const plan = this.profile.subscription.plan

      return this.profile.subscription?.isCustomTariff ?
        this.$t(`plans.${plan}.${plan}Custom`) :
        this.$t(`plans.${plan}.${plan}`)
    },
    cloudExperiment () {
      return this.experiments.find(el => el.name === EXPERIMENT_CLOUD_KEY_NAME)
    },

    activePlan() {
      const { subscription } = this.profile

      if (subscription && subscription.expiration) {
        const expDate = this.moment(this.profile.subscription.expiration).unix()
        const currentUnix = this.moment().unix()

        if (expDate > currentUnix) return true
      }

      return false
    },

    showNewsletterSwitcher () {
      return Boolean(this.profile && this.profile.showNewsletter !== undefined)
    },

    showNewsletterDivider () {
      return Boolean(this.profile?.subscription?.browserProfiles && this.showNewsletterSwitcher)
    },

    showNewsletter () {
      return this.localShowNewsletter;
    },

    showBackToSchoolBanner() {
      return false
    },

    showBlackFridayBanner() {
      return this.banners.blackFriday && this.isFeatureEnabled('black-friday-banner')
    },

    isFreePlanWithSingleProfile () {
      return (
        this.profile?.subscription?.plan === "free" &&
        this.profile.subscription.browserProfiles?.limit === 10
      );
    },

    profilesCountForCurrentMonth() {
      const { countForCurrentMonth } = this.profile.subscription.browserProfiles || {}
      return `${countForCurrentMonth} /`
    },

    nextMonthFirstDate() {
      const nextMonthFirstDay = moment().add(1, 'month').startOf('month')

      return nextMonthFirstDay.format('DD MMM YYYY HH:mm')
    },

    countsColorClass() {
      const { countForCurrentMonth, limitForCurrentMonth } = this.profile.subscription.browserProfiles || {}
      return this.monthlyProfileColor(countForCurrentMonth, limitForCurrentMonth)
    },
  },

  mounted() {
    const quizRequired = localStorage.getItem('quizRequired') === '1'
    const showQuizBlock = quizRequired || !localStorage.getItem('quizRequired')

    try {
      if (showQuizBlock) {
        this.$store.dispatch('main/openDialog', 'showQuizBlock')
      } else {
        this.$store.dispatch('main/closeDialog', 'showQuizBlock')
      }
    } catch (e) {
      console.log(`Error occurred on quiz show - ${e}`)
    }

    this.$store.dispatch('plans/reloadPaymentInfo')
    this.paymentResult = this.$route.query.paymentResult
  },

  async created() {
    if (this.$route.query && +this.$route.query.popTwoFactor) {
      this.$store.dispatch('main/openDialog', 'popTwoFactor')
      this.$router.replace({
        query: {
          ...this.$route.query,
          popTwoFactor: undefined
        }
      })
    }

    if (this.$route.query && +this.$route.query.dialogTwoFactor) {
      this.$store.dispatch('main/openDialog', 'enableTwoFactorAuthDialog')
      this.$router.replace({
        query: {
          ...this.$route.query,
          dialogTwoFactor: undefined
        }
      })
    }
    // If there is a verified query in url, that means that user comes from email verification
    // Authorize him in that case
    if (this.$route.query.verified === '1') {
      const accessToken = localStorage.getItem('confirmToken')
      const refreshToken = localStorage.getItem('confirmRefreshToken')

      if (accessToken && refreshToken) {
        await this.$store.dispatch('main/loadProfileForVerification', {
          accessToken,
          refreshToken,
        })

        localStorage.setItem('quizRequired', '1')

        await this.$store.dispatch('auth/setIsAuthenticated', accessToken)
        await this.$store.dispatch('main/setQuizBlock', true)

        localStorage.removeItem('confirmToken')
        localStorage.removeItem('confirmRefreshToken')
      }
    }

    await this.$store.dispatch('main/loadProfile')
    this.localShowNewsletter = this.profile.showNewsletter || false;

    window.Intercom('update', {
      LTV: this.profile.ltv,
      'Activity Type': this.profile.activityType,
    })

    await this.handleShowBackToSchoolBanner()
    await this.handleShowBlackFridayBanner()
    await this.getUserContact()
  },

  methods: {
    goToPlansCards() {
      this.$router.push({ name: 'Plans' })
      this.$store.dispatch('plans/setCase', 'upgrade')
      this.$amplitude.getInstance().logEvent('Click to Upgrade', {
        plan: this.profile.subscription.plan
      })
    },

    goToTrialPlansCards() {
      this.$router.push({ name: 'Plans' })
      this.$store.dispatch('plans/setCase', 'trial')
      this.$amplitude.getInstance().logEvent('Click to Upgrade', {
        plan: this.profile.subscription.plan
      })

    },
    async refreshProfile() {
      try {
        this.refreshLoading = true
        await this.$store.dispatch('main/loadProfile')
      } catch (error) {
        // error
      } finally {
        this.refreshLoading = false
      }
    },

    countsColor(count, limit) {
      if (count / limit <= 0.5) {
        return "#4CAF50"
      } else if (count / limit > 0.5 && count / limit <= 0.8) {
        return "#FF9800"
      } else if (count / limit > 0.8) {
        return "#F44336"
      }
      return "inherit"
    },
    isFreeOfCharge() {
      if(this.profile.subscription.plan === 'free'
      && this.profile.subscription.users.count > 1
      ){
        return  true
      }

      if (this.profile.subscription.plan === 'free'
          && this.profile.subscription.browserProfiles.limit === 10
          && this.profile.subscription.users.limit === 1) {
        return true
      } else {
        return false
      }
    },

    async handleTwoFactorAuthEnableClick () {
      await this.$store.dispatch('main/openDialog', 'enableTwoFactorAuthDialog')
    },

    handleChangeMessenger() {
      this.userChangedContactThisMonth ? this.changeRestrictionDialog() : this.changeMessengerDialog();
    },

    async saveDialogChangeMessenger(sendMessengerName, selectedMessengerValue) {
      if (!selectedMessengerValue) return this.changeMessengerDialog();

      const payload = {
        "messenger": sendMessengerName,
        "messengerIdentifier": selectedMessengerValue,
        "action": 'update'
      }
      try {
        const response = await this.api.post('/user/contact', payload);
        if (response?.data?.data) {
          this.updateMessengerData(response.data.data);
        }
      } catch (error) {
        console.error(error);
      }

      this.changeMessengerDialog()
    },

    async changeMessengerDialog() {
      this.openDialogChangeMessenger = !this.openDialogChangeMessenger
    },

    changeRestrictionDialog () {
      this.contactChangeRestriction = !this.contactChangeRestriction
    },

    handleTwoFactorAuthManageClick () {
      this.$store.dispatch('main/openDialog', 'manageTwoFactorAuthDialog')
    },

    async changeNewsletter (value) {
      this.localShowNewsletter = value;
      try {
        const accessToken = window.atob(
          window.decodeURIComponent(Cookies.get('dolphinAntyAccessToken'))
        )

        if (!accessToken) {
          console.error('Token not found')
        }

        const response = await this.apiV2.patch('/newsletter', {
          enabled: value
        }, {
          headers: {
            Authorization: `Bearer ${accessToken}`
          }
        });

        if (response && response.status === 200) {
          await this.$store.dispatch('main/loadProfile')
        } else {
          this.localShowNewsletter = !value;
        }
      } catch (err) {
        this.localShowNewsletter = !value;
        console.log(err)
      }
    },

    async handleShowBackToSchoolBanner () {
      try {
        const res = await this.api.get('/profile/quiz/4')
        if (res.data.success) return

        this.$store.dispatch('main/showBanner',  'backToSchool')
      } catch (err) {
        console.error(err)
      }
    },

    async handleShowBlackFridayBanner () {
      try {
        const res = await this.api.get('/profile/quiz/5')
        if (res.data.success) return

        this.$store.dispatch('main/showBanner',  'blackFriday')
      } catch (err) {
        console.error(err)
      }
    },

    async getUserContact () {
      try {
        const response = await this.api.get('/user/contact')
        if (response?.status === 200 && response.data?.data) {
          this.updateMessengerData(response.data.data);
        }
      } catch (err) {
        console.error(err)
      }
    },

    updateMessengerData(data) {
      const { messenger, messengerIdentifier, userChangedContactThisMonth } = data;

      if (!messenger || !messengerIdentifier) {
        return;
      }

      this.$store.dispatch('main/setSelectedMessenger', messenger);
      this.$store.dispatch('main/setSelectedMessengerValue', messengerIdentifier);
      this.$store.dispatch('main/setUserChangedContactThisMonth', userChangedContactThisMonth);
    },

    monthlyProfileColor(count, limit) {
      if (count / limit <= 0.9) {
        return "profile-limit-success";
      } else if (count === 500 && limit === 500) {
        return "profile-limit-error";
      } else if (count / limit >= 0.9) {
        return "profile-limit-warning";
      }
      return "inherit"
    },
  }
}
</script>

<style lang="scss">
  .twoFactorOnText {
    color: #4CAF50;
  }

  .limitForCurrentMonth-span {
    font-weight: bold;
  }

  .profile-limit-success {
    color: var(--v-text-success-base);
   }

  .profile-limit-warning {
    color: var(--v-text-warning-base);
  }

  .profile-limit-error {
    color: var(--v-text-error-base);
  }
</style>
